import React, { useState } from "react";
import { Button, Flex, Input, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { CATEGORIES } from "../../models/Communications";
import "./css/CommunicationsFilterPanel.css";

export interface CommunicationsFilterPanelProps {
    onApply: (search: string, category: string | undefined) => void;
}

export function CommunicationsFilterPanel({ onApply }: CommunicationsFilterPanelProps) {
    const [search, setSearch] = useState("");
    const [category, setCategory] = useState<string | undefined>(undefined);

    function handleApply() {
        onApply(search, category);
    }

    function handleClear() {
        setSearch("");
        setCategory(undefined);
    }

    return (
        <div className="cfil-panel">
            <Flex gap="middle" className="cfil-row">
                <Input
                    className="cfil-search"
                    placeholder="Cerca nel testo"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    suffix={<SearchOutlined />}
                />
                <Select
                    className="cfil-category"
                    placeholder="Categoria"
                    value={category}
                    onChange={setCategory}
                    allowClear
                    options={CATEGORIES.map((c) => ({ value: c, label: c }))}
                />
            </Flex>
            <Flex justify="flex-end" gap="middle" className="cfil-actions">
                <Button onClick={handleClear}>PULISCI</Button>
                <Button type="primary" onClick={handleApply}>
                    APPLICA
                </Button>
            </Flex>
        </div>
    );
}
